import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";

const testimonials = [
  {
    text: "We had a great experience with our driver Taj. We did tour in April and I definitely recommend safari with him! He also took a nice pictures",
    customer: "Aleksandra",
    image: "/images/home/dummy.jpg",
  },
  {
    text: "We had a very good experience with clear explanations and great information. Dune driving was awesome, and Rashid was very friendly and helpful throughout the tour.",
    source: "Review of: Dubai City Tour Full Day with Burj Khalifa Ticket At the Top",
    customer: "Alex",
    image: "/images/home/dummy.jpg",
  },
  {
    text: "We had an incredible desert safari experience. Everything was well organized, and our guide Mr. Zohaib was polite, professional, and provided excellent service.",
    source: "Review of: Dubai City Tour Full Day with Burj Khalifa Ticket At the Top",
    customer: "Shawal",
    image: "/images/home/dummy.jpg",
  },
];

export default function ReviewCTR() {
  const [current, setCurrent] = useState(0);

  const handlers = useSwipeable({
    onSwipedLeft: () =>
      setCurrent((prev) => (prev + 1) % testimonials.length),
    onSwipedRight: () =>
      setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length),
    trackMouse: true,
  });

  return (
    <div className="relative mt-12 md:mt-22 grid grid-cols-1 lg:grid-cols-2 items-stretch overflow-hidden">

      {/* LEFT CONTENT */}
      <div
        {...handlers}
        className="order-2 lg:order-1 flex flex-col justify-center p-[20px] lg:p-[90px] bg-[#f9f9f9] relative"
      >
        <div className="italic border border-[#fc9f1c] p-[20px] lg:p-[40px] mb-[25px]">
          <p className="text-[13px] text-[#606060] leading-[25px] lg:leading-[40px] mb-[10px]">
            {testimonials[current].text}
          </p>
          <p className="text-[13px] text-[#606060]">
            {/* – Someone famous in{" "}
            <span className="text-[#fc9f1c]">
              {testimonials[current].source}
            </span> */}
            Review of: Dubai Premium Red Dunes Safari Camel Ride and BBQ Dinner
          </p>
        </div>

        <div className="flex items-center gap-4 lg:gap-8">
          <img
            src={testimonials[current].image}
            alt="customer"
            className="w-[93px] h-[97px] rounded-full object-cover"
          />
          <h3 className="text-[14px] font-semibold text-[#606060]">
            {testimonials[current].customer}
          </h3>
        </div>

        {/* DOTS */}
        <div className="absolute bottom-4 right-4 flex gap-2">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full transition-colors duration-300 ${current === index ? "bg-[#fc9f1c]" : "bg-gray-400"
                }`}
            />
          ))}
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="order-1 lg:order-2 w-full h-full">
        <img
          src="/images/home/reviewhome.jpg"
          alt="review"
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
}
